import api from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Submit a demo request
 * @param {Object} demoData - Demo request data
 * @param {string} demoData.companyName - Company name
 * @param {string} demoData.vatNumber - VAT number (required)
 * @param {string} demoData.phoneNumber - Phone number
 * @param {string} demoData.email - Email address (required)
 * @param {string} demoData.message - Message (max 100 characters)
 * @returns {Promise} API response
 */
export const requestDemo = async (demoData) => {
  try {
    const response = await api.post('/demo-requests', demoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Send a contact message
 * @param {Object} contactData - Contact message data
 * @param {string} contactData.email - Email address (required)
 * @param {string} contactData.phoneNumber - Phone number
 * @param {string} contactData.message - Message (required)
 * @returns {Promise} API response
 */
export const sendContactMessage = async (contactData) => {
  try {
    const response = await api.post('/contact-messages', contactData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
